import React, {useEffect, useState } from "react";
import Slider from "react-slick";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/bundle";
import { FaHeart } from "react-icons/fa";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useNavigate } from "react-router-dom";
import "../Styles/Home.css";
import api from "../api";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        display: "block",
        position: "absolute",
        backgroundColor: "rgba(0, 0, 0, 0.29)",
        height: "auto",
        padding: "3px",
        width: "26px",
        borderRadius: "10px 50px 50px 10px",
      }}
      onClick={onClick}
    />
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        display: "block",
        position: "absolute",
        backgroundColor: "rgba(0, 0, 0, 0.29)",
        height: "auto",
        padding: "3px",
        width: "26px",
        borderRadius: "50px 10px 10px 50px",
      }}
      onClick={onClick}
    />
  );
}

// const settings = {
//    autoplay: true,
//   autoplaySpeed: 500,
//   infinite: true,
//   speed: 800,
//   slidesToShow: 6,
//   slidesToScroll: 1,
//   arrows: true,
//   // nextArrow: <SampleNextArrow />,
//   // prevArrow: <SamplePrevArrow />,
//   responsive: [
//     // {
//     //   breakpoint: 1300,
//     //   settings: {
//     //     slidesToShow: 4.5,
//     //   },
//     // },
//     // {
//     //   breakpoint: 1180,
//     //   settings: {
//     //     slidesToShow: 4,
//     //   },
//     // },
//     // {
//     //   breakpoint: 1060,
//     //   settings: {
//     //     slidesToShow: 3.5,
//     //   },
//     // },
//     {
//       breakpoint: 940,
//       settings: {
//         slidesToShow: 3,
//       },
//     },

//     {
//       breakpoint: 700,
//       settings: {
//         slidesToShow: 2.5,
//       },
//     },
//     {
//       breakpoint: 580,
//       settings: {
//         slidesToShow: 2,
//       },
//     },
//     {
//       breakpoint: 400,
//       settings: {
//         slidesToShow: 1.5,
//       },
//     },
//   ],
// };
const settings = {
    autoplay: true,
  autoplaySpeed: 5000,
    infinite: true,
  speed: 800,
  slidesToShow: 6,
  slidesToScroll: 1,
  arrows: true,
  // variableWidth: true, 
 
  responsive: [
    {
      breakpoint: 1030,
      settings: {
        slidesToShow: 5,
      },
    },
   
   
    {
      breakpoint: 870,
      settings: {
        slidesToShow: 4,
      },
    },

    {
      breakpoint: 580,
      settings: {
        slidesToShow: 3,
      },
    },
     {
       breakpoint: 420,
       settings: {
         slidesToShow: 2.5,
       },
     },
  ],
};
function PopularProoducts() {
  const navigate = useNavigate();
  const accessToken = localStorage.getItem("accessToken");
  const [productList, setProductList] = useState([]);
  const [loading, setLoading] = useState(true);
    const[isMobile,setIsMobile]=useState(window.innerWidth <= 730)

useEffect(() => {
  if (productList.length > 0) {
    setLoading(false);
  }
}, [productList]);

  // const [clicked, setClicked] = useState(false);

  useEffect(() => {
    getProductList();
  }, []);
  const getProductList = async () => {
    console.log(accessToken);


    try {
      const response = await api.get(
        `/user_api/product/trending-list?access_token=${JSON.parse(accessToken)}`
      );

      setProductList(response.data.product_list);
      // setClicked(response.data.add_to_cart);

    } catch (error) {
      console.log("Error fetching products:", error);
    }
  };

  const addWishlist = async (id) => {
 
    if (!accessToken) {
      navigate("/login");
      return;
    }

    try {
      const response = await api.post(`/user_api/add-wishlist`, {
        access_token: JSON.parse(accessToken),
        product_id: id,
      });
      console.log(response.data);
      
      getProductList()
    } catch (error) {
      console.log("Error saving wishlist:", error);
    }
  };
 
  const handlePress = async (url, clicked) => {
    console.log("uyghtgh", clicked);
    console.log(accessToken);
    
    if (!accessToken) {
      navigate("/login");
      return;
    }

    try {
      if (!clicked) {
        navigate("/cart");
      } else {
        const response = await api.post(`/user_api/cart/add-to-cart-web-home`, {
          access_token: JSON.parse(accessToken),
          product_url: url,
          qty: 1,
        });
        console.log("jyghjgjgjh", response.data);
        if (response.data.status === "success") {
          getProductList();
        } else {
          console.log("something fisshy");
        }
      }
    } catch (error) {
      console.log("Error adding cart:", error);
    } finally {
    }
  };
  return (
   

      <div className="products-grid">
<Slider {...settings}>
  {loading
    ? Array.from({ length: 6 }).map((_, index) => (
        <div key={index} className="product-card" style={{ flexDirection: 'column', height: 'auto' }}>
          <div className="discount-badge pulse-animation">
            <Skeleton width={60} height={20} />
          </div>

          <div className="product-image-container">
            <Skeleton height={150} width="100%" />
          </div>

          <div className="product-info1" style={{ padding: "0px" }}>
            <h4 className="product-name" style={{ marginTop: "0px" }}>
              <Skeleton width={`80%`} height={20} />
            </h4>

            <div className="price-container">
              <Skeleton width={60} height={15} />
              <Skeleton width={60} height={15} />
            </div>

            <Skeleton height={35} width={120} style={{ marginTop: 10 }} />
          </div>
        </div>
      ))
    : productList.slice(0, 20).map((product) => (
        <div
          key={product.id}
          onClick={() => navigate(`/Product_details_final/${product.product_url}`)}
          className="product-card-item"
          style={{ flexDirection: "column", height: "auto" }}
        >
          {product.discout ===0?" ":
          <div className="discount-badge pulse-animation">
            {product.discout}% OFF
          </div>
          }

         <div className="product-image-wrapper">
            {product.product_image_path?.[0]?.real_image_path ? (
              <img
                src={product.product_image_path[0].real_image_path}
                alt={product.product_name}
                className="product-card-image hover-zoom"
                loading="lazy"
              />
            ) : (
              <div className="image-placeholder">
                <i className="fas fa-image placeholder-icon"></i>
              </div>
            )}
          </div>

          <div className="product-info1" style={{ padding: "0px" }}>
            <h4 className="product-name" style={{ marginTop: "0px" }}>
               {isMobile?`${product.product_name.substring(0, 20)}...`:
              product.product_name.length > 30
                ? `${product.product_name.substring(0, 30)}...`
                : product.product_name}
            </h4>

            <div className="product-pricing">
              <span className="selling-price">AED{product.selling_price}</span>
              <span className="original-price">AED{product.initial_cost}</span>
            </div>

            <button
              className="add-to-cart-btn"
              onClick={(e) => {
                e.stopPropagation();
                handlePress(product.product_url, product.add_to_cart);
              }}
            >
              <i className="fas fa-shopping-cart"></i>
              <span>
                {product.add_to_cart ? "ADD TO CART" : "GO TO CART"}
              </span>
            </button>
          </div>

          <div
            style={{
              position: "absolute",
              top: 10,
              right: 10,
              cursor: "pointer",
              zIndex: 999,
            }}
            onClick={(e) => {
              e.stopPropagation();
              addWishlist(product.id);
            }}
          >
            <FaHeart
              style={{
                color: product.wish_button === "checked" ? "red" : "gray",
                fontSize: "20px",
                transition: "color 0.3s",
              }}
            />
          </div>
        </div>
      ))}
</Slider>

      </div>
    
  );
}

export default PopularProoducts;
